import { Progress } from '@cimplico/components';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { WorkpaperProcedure } from '../../types/workpaper-procedure';
import { AnimatePresence, motion } from 'framer-motion';
import WorkpaperProcedureRow from './WorkpaperProcedureRow';

type WorkpaperProcedureCategorySectionProps = {
    categoryDetails: {
        categoryId?: string;
        categoryName: string;
        procedures: WorkpaperProcedure[];
        isCollapsed: boolean;
        totalProcedureCount: number;
        completedProcedureCount: number;
    };
    selectedProcedures: WorkpaperProcedure[];
    onToggleCollapse: (categoryId: string) => void;
    onProcedureChecked: (procedure: WorkpaperProcedure) => void;
};

function WorkpaperProcedureCategorySection({
    categoryDetails,
    selectedProcedures,
    onToggleCollapse,
    onProcedureChecked,
}: WorkpaperProcedureCategorySectionProps): JSX.Element {
    function handleToggleShowProcedures(): void {
        onToggleCollapse(categoryDetails.categoryId || 'other');
    }

    return (
        <>
            <div className="py-4 flex items-center justify-between">
                <div className="flex gap-2 items-center">
                    <button className="text-indigo-600" onClick={handleToggleShowProcedures}>
                        <ChevronDownIcon className={`h-5 w-5 duration-200 ${categoryDetails.isCollapsed ? '-rotate-90' : ''}`} />
                    </button>
                    <p className="text-gray-800 text-sm font-medium">{categoryDetails.categoryName}</p>
                    <p className="text-gray-600 text-sm">
                        {categoryDetails.completedProcedureCount}/{categoryDetails.totalProcedureCount}
                    </p>
                    <Progress
                        type="circle"
                        size="small"
                        percent={(categoryDetails.completedProcedureCount / categoryDetails.totalProcedureCount) * 100}
                    />
                </div>
            </div>
            <AnimatePresence initial={false}>
                {!categoryDetails.isCollapsed && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ height: { duration: 0.2 } }}
                        className="pl-1 overflow-hidden flex flex-col gap-2"
                    >
                        {categoryDetails.procedures.map((procedure) => {
                            return (
                                <WorkpaperProcedureRow
                                    key={procedure.id}
                                    workpaperProcedure={procedure}
                                    selectedProcedures={selectedProcedures}
                                    onProcedureChecked={onProcedureChecked}
                                />
                            );
                        })}
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}

export default WorkpaperProcedureCategorySection;
